// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--eO0Gz","text":"style-module--text--RatIJ","slider":"style-module--slider--3cDE2"};